import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  //Size Value; xs,sm, md, lg,xl
  @Input() size: string;

  //Type Value; badge, circle, rounded, pill, outline-primary, badge-outline-secondary, badge-outline-success, badge-outline-danger, badge-outline-warning, badge-outline-info, badge-outline-light, badge-outline-dark
  @Input() type: string;

  //Color Value; primary, secondary, success, danger, warning, info, light, dark
  @Input() color: string;

  //Light Value: Light
  @Input() light: string;

  @Input() text: string;

  @Input() class: string;

}
